export default "__VITE_ASSET__DhvULOjI__"